
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CompanyInfoForm } from "./company/CompanyInfoForm";

const CompanyTab = () => {
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>Informações da Empresa</CardTitle>
          <CardDescription>
            Atualize as informações da sua empresa
          </CardDescription>
        </CardHeader>
        <CardContent>
          <CompanyInfoForm />
        </CardContent>
      </Card>
    </>
  );
};

export default CompanyTab;
